import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localePl from '@angular/common/locales/pl';
import localeEn from '@angular/common/locales/en';
import { StorageService } from '@shared/services/storage.service';

registerLocaleData(localeDe, 'de');
registerLocaleData(localePl, 'pl');
registerLocaleData(localeEn, 'en');

@Pipe({
  name: 'currencyFormatter',
})
export class CurrencyFormatterPipe implements PipeTransform {
  cp: CurrencyPipe = new CurrencyPipe('en-US');

  constructor(public storage: StorageService) {}

  transform(currency: string, currentLocale = 'pl'): string {
    let result = null;
    result = this.cp.transform(0, currency, 'symbol', '1.0-0', currency === 'USD' ? null : currentLocale);
    result = result.replace(' ', '');
    return result.replace('0', '');
  }
}
